// import "core-js/stable";
// import "regenerator-runtime/runtime";

self.components = self.components || {};

/**
 * Imports base module vue
 */

import './vue';
// import(/* webpackPrefetch: true */ './vue');


/**
 * Imports base modules
 */
import './components/form';
// import './components/navigation';
import './components/navigationEnter';
import './components/tools/Scroll';
import {init as initVideo} from './components/tools/Video';

/**
 * Exec base modules
 */
initVideo()

/**
 * File load Asyns / Defer
 * DOMContentLoaded not triggered
 */
import './components/front';

/**
 * Blocks
 */
import './blocks/index'

/**
 * Exec in-html functions
 */

// while ( pagefunctions.length ){
//     pagefunctions.shift().call();
// }

// const front = require('./components/front.js');
// const form = require('./components/form.js');
// const frontParticles = require('./components/frontParticles.js');

/**
 * Window load
 */
// document.addEventListener("DOMContentLoaded", () => {
//
//     self.components.front = front.frontComponent();
// });


